.tinycld-mail-editor .ProseMirror {
    padding: 0;
    min-height: 100px;
    font-size: 14px;
    line-height: 1.5;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    outline: none;
    flex: 1;
}

.tinycld-mail-editor .ProseMirror p.is-editor-empty:first-child::before {
    color: var(--editor-placeholder-color, #aaa);
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
}

.tinycld-mail-editor .ProseMirror blockquote {
    border-left: 3px solid var(--editor-placeholder-color, #aaa);
    padding-left: 1rem;
    margin-left: 0;
}

.tinycld-mail-editor .ProseMirror a {
    color: var(--editor-primary-color, #0066cc);
    text-decoration: underline;
}

.tinycld-mail-editor .ProseMirror ul,
.tinycld-mail-editor .ProseMirror ol {
    padding-left: 1.5rem;
}
